import React, {Component} from 'react';
import {Breakpoints} from "./theme-breakpoints";
import {themeStyles} from "./theme-styles";
import {debounce} from "lodash";

//componentStyles :: (func) Function with injected responsive props that returns all styles objects
//resizable :: (bool) Re-render WrappedComponent on window resize
const responsiveDefinitions = (WrappedComponent, componentStyles = null, resizable = true, rerenderDebounce = 100) => {

    class ResponsiveDefinitions extends Component {

        constructor(props) {
            super(props);
            this.state = {loadedDefinitions: false};
            this.mounted = false;
        }

        getWidth = () => window.innerWidth;
        getHeight = () => window.innerHeight;

        gotNewDimensions = () => {
            const {width, height} = this.state;
            const windowWidth = this.getWidth(), windowHeight = this.getHeight();

            return windowWidth !== width || height !== windowHeight;
        };

        generateResourcesAndSaveOnState = () => {
            const width = this.getWidth(), height = this.getHeight();
            const properties = this.generateProperties(width, height);
            this.setState({...properties}, () => {
                const allThemeStyles = themeStyles(properties);
                const definitions = componentStyles
                    ? {...allThemeStyles, ...componentStyles({...properties, ...allThemeStyles})}
                    : allThemeStyles;
                const all = {...properties, ...definitions, loadedDefinitions: true};
                this.setState(all);
            });
        };

        generateProperties = (width, height) => {
            const breakPoint = this.determineBreakpoint(width);
            return {
                width: width,
                height: height,
                currentBreakpoint: breakPoint,
                isXXS: breakPoint === Breakpoints.XXS.name,
                isXS: breakPoint === Breakpoints.XS.name,
                isSM: breakPoint === Breakpoints.SM.name,
                isMD: breakPoint === Breakpoints.MD.name,
                isLG: breakPoint === Breakpoints.LG.name,
                isXLG: breakPoint === Breakpoints.XLG.name,
                matches: this.matches,
                evaluate: this.evaluate
            };
        };

        matches = (xxs = true, xs = true, sm = true, md = true, lg = true, xlg = true) => {
            const {isXXS, isXS, isSM, isMD, isLG, isXLG} = this.state;
            return !!((isXXS && xxs)|| (isXS && xs) || (isSM && sm) || (isMD && md) || (isLG && lg) || (isXLG && xlg));
        };

        evaluate = (xxsData = null, xsData = null, smData = null, mdData = null, lgData = null, xlgData = null) => {
            const {isXXS, isXS, isSM, isMD, isLG} = this.state;
            if (isXXS) {
                return xxsData;
            }
            if (isXS) {
                return xsData;
            }
            if (isSM) {
                return smData;
            }
            if (isMD) {
                return mdData;
            }
            if (isLG) {
                return lgData;
            }
            return xlgData;
        };

        determineBreakpoint = windowWidth => {
            if (windowWidth <= Breakpoints.XXS.max) {
                return Breakpoints.XXS.name;
            }
            if (windowWidth <= Breakpoints.XS.max) {
                return Breakpoints.XS.name;
            }
            if (windowWidth <= Breakpoints.SM.max) {
                return Breakpoints.SM.name;
            }
            if (windowWidth <= Breakpoints.MD.max) {
                return Breakpoints.MD.name;
            }
            if (windowWidth <= Breakpoints.LG.max) {
                return Breakpoints.LG.name;
            }

            return Breakpoints.XLG.name;
        };

        updateDimensions = () => {
            if (this.mounted && this.gotNewDimensions()) {
                this.generateResourcesAndSaveOnState();
            }
        };

        componentDidMount() {
            if (resizable) {
                window.addEventListener("resize", debounce(this.updateDimensions, rerenderDebounce));
            }
        };

        componentWillUnmount() {
            this.mounted = false;

            if (resizable) {
                window.removeEventListener("resize", this.updateDimensions);
            }
        }

        componentWillMount() {
            this.mounted = true;
            this.updateDimensions();
        }

        render() {
            return <WrappedComponent Styles={{...this.state}} {...this.props}/>;
        }
    }

    return ResponsiveDefinitions;
};

export default responsiveDefinitions;